export const mockFlights = [
  // One-way flight
  {
    id: 1,
    operatorCode: "AIRFRANCE",
    price: "322",
    outbound_date: "Fri 14 Feb",
    outbound_time: "19:35",
    outbound_arrival_time: "21:55",
    outbound_arrival_date: "Fri 14 Feb",
    origin: "LHR",
    destination: "CDG",
    duration: "01h 20m",
    stops: "Non-stop",
    departure_terminal: "Terminal 4",
    arrival_terminal: "Terminal 2E",
    baggage: {
      fare_type: "Light",
      personal_item: {
        dimensions: "18 x 14 x 8 inches",
        included: true,
      },
      carry_on: {
        dimensions: "1 x 12kg",
        included: true,
      },
      checked_bags: {
        included: false,
      },
    },
  },
  // Return flight
  {
    id: 2,
    operatorCode: "AIRFRANCE",
    price: "400",
    outbound_date: "Fri 14 Feb",
    outbound_time: "23:35",
    outbound_arrival_time: "01:55",
    outbound_arrival_date: "Sat 15 Feb",
    return_date: "Sun 16 Feb",
    return_time: "21:00",
    return_arrival_time: "21:25",
    origin: "LHR",
    destination: "CDG",
    duration: "01h 20m",
    return_duration: "01h 25m",
    stops: "Non-stop",
    return_stops: "Non-stop",
    departure_terminal: "Terminal 4",
    arrival_terminal: "Terminal 2E",
    return_departure_terminal: "Terminal 2E",
    return_arrival_terminal: "Terminal 4",
    baggage: {
      fare_type: "Light",
      personal_item: {
        dimensions: "18 x 14 x 8 inches",
        included: true,
      },
      carry_on: {
        dimensions: "1 x 12kg",
        included: true,
      },
      checked_bags: {
        included: false,
      },
    },
  },
  // Flight with stopover
  {
    id: 3,
    operatorCode: "AIRFRANCE",
    price: "550",
    outbound_date: "Fri 14 Feb",
    outbound_time: "10:35",
    outbound_arrival_time: "22:55",
    outbound_arrival_date: "Fri 14 Feb",
    origin: "LHR",
    destination: "SIN",
    duration: "12h 20m",
    stops: "1 stop",
    departure_terminal: "Terminal 4",
    arrival_terminal: "Terminal 3",
    stopover: {
      airport: "DXB",
      arrival_time: "16:35",
      departure_time: "18:55",
      duration: "2h 20m",
      terminal: "Terminal 1",
    },
    baggage: {
      fare_type: "Standard",
      personal_item: {
        dimensions: "18 x 14 x 8 inches",
        included: true,
      },
      carry_on: {
        dimensions: "1 x 12kg",
        included: true,
      },
      checked_bags: {
        dimensions: "1 x 23kg",
        included: true,
      },
    },
  },
];
